module.exports = __webpack_public_path__ + "ebe288c668ea3be1aa9e287613cc6ac8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/army-helmet.png
// module id = 2769
// module chunks = 0